export const OfferRequestProcessSettingNames = {
  refererId: 'refererId',
  presetId: 'presetId',
  voucherCode: 'voucherCode',
  filterValues: 'filterValues',
  useRecommendedFilter: 'useRecommendedFilter'
};
